import React from 'react';

import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit';
import { BankTitle } from '../BankTitle';

import styles from './styles.css';

import { transformNumToString } from 'shared/common/utils/transformNumToString';
import { useSelector } from 'react-redux';
import { selectCalculatorValues } from '../../selectors/selectCalculatorValues';
import { NBSP } from '../../../common/constants';

interface IHeaderProps {}

export const Header: React.FC<IHeaderProps> = () => {
  const { bankName, logoPath, discountMortgagePercent, realEstateType } = useSelector(selectCalculatorValues);
  const discountMortgage = transformNumToString(discountMortgagePercent);
  const tags = ['Квартира', realEstateType];

  return (
    <div>
      <BankTitle bankName={bankName} tags={tags} logoUrl={logoPath} />
      <div className={styles['text']}>
        <div className={styles['title']}>
          <ArticleHeading4>
            Ипотека на{NBSP}вторичку со скидкой {discountMortgage}%
          </ArticleHeading4>
        </div>
        <ArticleParagraph2>
          Только для{NBSP}квартир, участвующих в{NBSP}программе: они{NBSP}отмечены значком «Скидка на ипотеку{NBSP}
          {discountMortgage}%»
        </ArticleParagraph2>
      </div>
    </div>
  );
};
